/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';


import Media from 'react-media';
import mbpLogger from 'mbp-logger';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Switch as MuiSwitch, CircularProgress, Button, Grid, FormControl } from '@material-ui/core';
import { RecipientBookContextProvider } from '../../../Account/components/AddressBook/RecipientBook/Common/Context/RecipientBookContext';

// Style
import { useStyles as useSwitchStyles } from '../AddressBook/RecipientBook/Common/Assets/Style/SwitchStyle';

// Helper
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { useSelector } from 'react-redux';
import { getOperatingSystem } from '../../../../../state/ducks/App/ducks/Config/Config-Helpers';
import { getUserProfile } from '../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { getCurrentBrandId, getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { formatPhoneNumber } from '../../utils/formater';
import LinkOpenChat from '../../common/LinkOpenChat';
import { unmaskPhoneNumber } from '../AddressBook/RecipientBook/Common/Helpers/Helpers';
import TextFieldHelper from '../AddressBook/RecipientBook/Common/Helpers/TextFieldHelper';
import { getFeatureFlag } from '../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';

// API
import { fetchEmailSubscribeStatus } from '../../../../../apis/account-apis/fetchEmailSubscribeStatus';
import { fetchCustomerReminderSubscriptionInfo } from '../../../../../apis/account-apis/RecipientBook-apis/fetchCustomerReminderSubscriptionInfo';
import { updateEmailSubscribeStatus } from '../../../../../apis/account-apis/updateEmailSubscribeStatus';
import { updateCustomerReminderSubscriptionInfo } from '../../../../../apis/account-apis/RecipientBook-apis/updateCustomerReminderSubscriptionInfo';

// Component
import AccountHome from '../MyAccount/AccountHome';
import { commonUseStyles } from '../../style/commonStyles';
import { getAppRoutePrefix } from '../../../../helpers/common/helper';
import GenericSkeleton from '../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';

const useStyles = makeStyles((theme) => ({
    communicationCenterContainer: {
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            maxWidth: '100%'
        },
        '& h2, & p, & span, & a': {
            fontStyle: 'normal !important',
            lineHeight: '24px',
            letterSpacing: '0.16px !important'
        }
    },
    communicationCenterHeaderContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            marginLeft: '75px',
        },
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            alignItems: 'center',
        },
    },
    communicationCenterHeader: {
        fontSize: '32px !important',
        fontWeight: '700 !important', // *** tech debt css -> main.js
        margin: '40px 0px !important',
        textTransform: "capitalize !important",
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            margin: '24px 0px !important',
            fontSize: '24px !important',
            lineHeight: 'normal'
        },
    },
    bodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        '& > div': {
            gap: '24px',
        },
        '& > div:last-child': {
            marginBottom: '20px',
        },
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            marginLeft: '60px'
        },
        '& .reminder-notification': {
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
            borderRadius: '3px',
            padding: '32px',
            [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                marginLeft: '16px', // this is only being added in as a temporary fix for desktop margin with the left menu. This will eventually be replaced by the grid system design
            },
            '& h2, h3': {
                marginBottom: '5px',
                '& ~hr': {
                    margin: '20px 0',
                    '&.edit': {
                        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                            marginTop: '100px',
                        },
                    }
                },
            },
            '& .field-container': {
                height: '55px',
                marginTop: '30px',
                '& > div': {
                    width: '300px',
                    display: 'inline-block',
                    marginRight: '20px',
                    [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                        width: '100%',
                        marginBottom: '20px',
                    },
                    '& > div': {
                        marginBottom: '0 !important',
                        '& input': {
                            height: '100%',
                        },
                    },
                },
                '& button': {
                    float: 'unset',
                },
                '& div, button': {
                    height: '100%',
                },
                '& ~ hr': {
                    [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                        marginTop: '100px',
                    },
                },
                '&.error': {
                    marginBottom: '40px',
                    '& > div': {
                        marginBottom: '40px',
                    },
                    '& ~ hr': {
                        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                            marginTop: '120px',
                        },
                    },
                },
            },
            '& .radio-btn': {
                float: 'right',
                '& > div': {
                    top: '0',
                    marginLeft: 0,
                }
            },
            '& .note': {
                padding: '10px',
                borderRadius: '2px',
                marginTop: '20px',
                backgroundColor: '#ece9e9',
            },
            '& .links-container': {
                [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
                    width: '70%',
                    display: 'inline-block',
                },
            }
        },
    },
    sectionHeader: {
        fontSize: '20px !important', // *** tech debt css -> variables.js
        fontWeight: '700 !important',
        marginTop: '0',
        letterSpacing: '1.5px !important',
        textTransform: 'none !important', // *** tech debt css -> main.js
        color: "#000000 !important" // *** tech debt css -> main.js
    },
    sectionCustomizeCatalog: {
        fontSize: '16px !important', // *** tech debt css -> variables.js
        fontWeight: '700 !important',
        marginTop: '0',
        textTransform: 'none !important', // *** tech debt css -> main.js
        color: "#000000 !important", // *** tech debt css -> main.js
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            fontSize: '20px !important'
        },
    },
    cardContainer: {
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
        height: '393px',
        borderRadius: '3px',
        padding: '32px',
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            marginLeft: '16px', // this is only being added in as a temporary fix for desktop margin with the left menu. This will eventually be replaced by the grid system design
        },
        display: 'flex',
        flexDirection: 'column',
        flexBasis: 'min-content',
        '& p:not(#legalCopy), & p:not(#subscribedText), & span:not(#switchTextOn), & span:not(#switchTextOff), & span, & b, & a': {
            fontSize: '16px !important',
        },
        '& p#legalCopy, & p#subscribedText, & span:not(#switchTextOn), & span:not(#switchTextOff),': {
            fontSize: 'inherit !important',
        },
        '& span(#switchTextOn), & span(#switchTextOff)': {
            fontSize: '14px !important',
        },
        '& > p': {
            marginBottom: '0 !important',
        }
    },
    CTAButton: {
        textDecoration: 'underline',
        textTransform: 'none',
        maxWidth: 'fit-content',
        padding: '0px !important',
        fontWeight: '700 !important',
        color: `${theme.palette.colorPrimaryAccountCtaButton} !important`,
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            backgroundColor: '#ffff !important',
            border: 'none !important',
            minWidth: '75px !important',
        },
        '&:hover': {
            textDecoration: 'underline',
        }
    },
    cardBody: {
        fontSize: '16px !important',
    },
    '& p': {
        fontSize: '16px !important'
    },
    drawerPopUp: {
        width: '100%',
        height: '260px',
        padding: '30px',
        borderRadius: '3px',
        boxShadow: '0px 0px 10px 0px rgba(47, 47, 47, 0.25)',
        '& div': {
            marginBottom: '10px',
        },
        '& h3': {
            marginTop: 0,
            textAlign: 'center',
            fontSize: '16px',
            marginBottom: '34px',
        },
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            height: 'auto',
            width: 'auto',
            padding: 0,
        },
    },
    disclaimer: {
        fontSize: '14px',
    },
    closeIcon: {
        position: 'absolute',
        top: '-18px',
        right: '-20px',
        cursor: 'pointer',
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            top: '-25px',
            right: '-48px',
        },
    },
    switchOn: {
        left: '10px',
        color: '#FFFFFF',
        paddingTop: '1px',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            paddingTop: '0px',
        },
    },
    switchOff: {
        left: '32px',
        color: '#FFFFFF',
        paddingTop: '1px',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            paddingTop: '0px',
            left: '30px',
        },
    },
    switchRoot: {
        width: 69,
        height: 34,
        padding: 2,
    },
    switchBaseOff: {
        padding: '6px',
        top: '0px',
    },
    switchBaseOn: {
        left: '12px',
        padding: '6px',
        top: '0px',
    },
    subscribed: {
        display: 'flex',
        justifyContent: 'center',
        color: '#058942',
        fontSize: '12px !important',
        position: 'absolute',
        top: '45px',
        width: '100%',
        marginTop: '-15% !important',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            top: '52px',
            marginTop: '-25% !important',
        },
    },
    root: {
        width: 66,
        height: 34,
        padding: 0,
        borderRadius: '18px',
    },
    thumb: {
        width: 22,
        height: 22,
        color: '#FFFFFF'
    },
    chat: {
        fontSize: '16px !important',
        color: '#1F6BC6'
    },
    switchContainer: {
        display: 'flex',
        justifyContent: 'start',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            justifyContent: 'space-between',
        },
    },
    switchInnerContainer: {
        position: 'relative',
        height: 'fit-content',
        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            marginLeft: '400px',
        },
    },
    switchTrack: {
        borderRadius: 20,
        backgroundColor: '#000000 !important',
        opacity: '1 !important',
        transition: theme.transitions.create(['background-color', 'border']),
    },
    switchOffBg: {
        backgroundColor: '#C4C4C4 !important'
    }
}));

const schemaForCommunicationCenter = Joi.object({
    phoneNumber: Joi.string()
        .trim()
        .pattern(/^\(?([1-9]\d{2})\)? \d{3}-\d{4}$/)
        .min(14)
        .max(14)
        .required()
        .messages({
            'string.empty': 'Mobile number is required.',
            'string.min': 'Mobile number must be 10 digits long.',
            'string.max': 'Mobile number must be 10 digits long.',
            'string.pattern.base': 'Please enter a valid mobile number.',
        })
        .label('Mobile number'),
});

const CommunicationCenter = () => {
    const classes = useStyles();
    const customClasses = commonUseStyles();
    const switchStyles = useSwitchStyles();
    const queryClient = useQueryClient();
    const operatingSystem = getOperatingSystem().toLowerCase();

    /* Testing Enterprise Btn */
    const [isEnterpriseBtnShowing, setIsEnterpriseBtnShowing] = useState(false);
    const isShowingReminderPreferences = useSelector(getFeatureFlag('sms-reminder-notification-preferences'));
    const cookies = new Cookies();
    const enterpriseBtnCookieEnabled = parseInt(cookies.get('entBtn')) === 1 || false;

    useEffect(() => {
        if (enterpriseBtnCookieEnabled && !isEnterpriseBtnShowing) {
            setIsEnterpriseBtnShowing(true);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }, []);

    const methods = useForm({
        mode: 'all',
        resolver: joiResolver(schemaForCommunicationCenter),
        defaultValues: {
            phoneNumber: "",
        },
    });
    const { register, formState: { errors } } = methods;
    const phoneNumber = methods.getValues('phoneNumber');

    const brandsEmailOpt = {
        FB: '18B',
        FBQ: '18B',
        HD: 'HND',
        WF: 'WLF',
        BRY: 'BERRIES',
        VC: 'VTC',
        CSG: 'CL',
    };

    const { email, ContactId } = useSelector(getUserProfile)
    const brandData = useSelector(getBrand);
    const brandId = useSelector(getCurrentBrandId);
    const isStandaloneAppChatLinkHidden = useSelector(getFeatureFlag('app-standalone-account-hide-links'))?.includes('chat');
    const brand = (Object.keys(brandsEmailOpt).includes(brandId) ? brandsEmailOpt[brandId] : brandId) || '18F';
    const [isEditingPhoneNumber, setIsEditingPhoneNumber] = useState(true);
    const [checked, setChecked] = useState(false);
    const [showSubscriptionStatus, setShowSubscriptionStatus] = useState(false);
    const [apiErrorMessage, setApiErrorMessage] = useState('');
    const [reminderNotification, setReminderNotification] = useState(false);

    const breakpointExpr = `(min-width: ${(CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
    const supportLinks = {
        terms_of_use: `https://www.${brandData['domain-name']}.com/About-Us-Terms-of-Use`,
        privacy_notice: `https://www.${brandData['domain-name']}.com/About-Us-Privacy-Policy`,
    };

    // should clean up global styles and make sure they don't become overriden by the main.js styles
    const UPDATE_FAIURE = 'We can\'t update your email notification setting right now. Please try again later.';

    // fetch email subscription status
    const fetchEmailSubscribeResponse = useQuery({
        queryKey: 'fetchEmailSubscribeStatus',
        queryFn: () => fetchEmailSubscribeStatus({
            retrieveEmailRequest:
                {
                    email,
                    siteId: brand,
                    sourceSystem: "SSP",
                }
        }),
        staleTime: 'Infinity',
        refetchOnWindowFocus: false,
    });

    const isUserSubscribedToMarketingEmails = fetchEmailSubscribeResponse.data?.data?.retrieveEmailResponse?.retrieveEmailResponseResult?.retrieveEmailResult?.retrieveEmailMessage === 'Active';

    useQuery({
        queryKey: 'fetchCustomerReminderSubscriptionInfo',
        queryFn: () => fetchCustomerReminderSubscriptionInfo(ContactId),
        staleTime: 'Infinity',
        refetchOnWindowFocus: false,
        onSuccess: (response) => {
            setReminderNotification(response.data?.SMSOptInAll);
            methods.reset({ phoneNumber: formatPhoneNumber(response.data?.reminderPhone) });
            response.data?.reminderPhone && setIsEditingPhoneNumber(false);
        },
    });

    const updatedCustomerReminderInformation = useMutation({
        mutationFn: updateCustomerReminderSubscriptionInfo,
        onSuccess: (response) => {
            setReminderNotification(response.data?.SMSOptInAll);
            methods.reset({ phoneNumber: formatPhoneNumber(response.data?.smsPhoneNumber) });
        },
        onError: (err) => {
            const error = (err.message).includes('422') ? 'Please add contacts to your address book to add mobile number.' : 'Something went wrong. Please try again.';
            setApiErrorMessage(error);
            mbpLogger.logError({
                function: 'updatedCustomerReminderInformation',
                appName: process.env.npm_package_name,
                module: 'Communication Center.js',
                message: `Error updating customer phone number from Communications Center`,
                err,
            });
        },
    });

    // update email subscription status
    const updateEmailSubscribeStatusMutation = useMutation({
        mutationFn: updateEmailSubscribeStatus,
        onSuccess: () => queryClient.invalidateQueries(['fetchEmailSubscribeStatus']),
    })

    const handleChange = (e) => {
        if (checked !== e.target.checked && showSubscriptionStatus === false) {
            setShowSubscriptionStatus(true);
        }
        setChecked(e.target.checked);
        let updateEmailRequestPayload = { 
            updateEmailRequest: {
                siteId: brand,
                email,
                sourceSystem: "SSP",
            }
        };
        if (e.target.checked) {
            updateEmailRequestPayload.updateEmailRequest.action = 'SUBSCRIBE';
            updateEmailSubscribeStatusMutation.mutate(updateEmailRequestPayload)
        } else {
            updateEmailRequestPayload.updateEmailRequest.action = 'DELETE';
            updateEmailSubscribeStatusMutation.mutate(updateEmailRequestPayload)
        }
    }

    const getSubscriptionStatus = () => {
        if (fetchEmailSubscribeResponse.isLoading || updateEmailSubscribeStatusMutation.isLoading) {
            return <div className={customClasses.gridAlign}><CircularProgress size={10} /></div>
        }

        setTimeout(() => {
            setShowSubscriptionStatus(false);
        }, 5000);

        return (isUserSubscribedToMarketingEmails) ? 'Subscribed' : 'Unsubscribed';
    };

    const getPreferenceStatus = () => {
        if (fetchEmailSubscribeResponse.isLoading || updatedCustomerReminderInformation.isLoading) {
            return <p id="subscribedText" className={classes.subscribed}>
                <div className={customClasses.gridAlign}><CircularProgress size={10} /></div>
            </p>
        }
    };

    const onMobileNumberSave = (data) => {
        setIsEditingPhoneNumber(false);
        updatedCustomerReminderInformation.mutate({
            contactId: ContactId,
            data: {
                smsPhoneNumber: unmaskPhoneNumber(data.phoneNumber),
                SMSOptInAll: data.SMSOptInAll ?? reminderNotification,
            }
        });
    };

    const handleEnableReminderNotification = async ({ target }) => {
        // errors.phoneNumber will make sure the validated number is getting passed
        if (!errors.phoneNumber && await methods.trigger("phoneNumber")) {
            onMobileNumberSave({
                phoneNumber,
                SMSOptInAll: !target.checked
            });
        }
    };

    return (
        <RecipientBookContextProvider>
            <Grid item xs={12} sm={10} className={classes.communicationCenterContainer}>
                <Media query={breakpointExpr}>
                    {(matches) => (
                        !matches && (
                            <div className={customClasses.container}>
                                <AccountHome />
                            </div>
                        )
                    )}
                </Media>
                <div className={classes.communicationCenterHeaderContainer}>
                    <h1 className={classes.communicationCenterHeader}>
                        Communication Center
                    </h1>
                </div>
                <div className={classes.bodyContainer}>
                    <div className={classes.cardContainer}>
                        <h2 id="marketing-header" className={`${classes.sectionHeader} ${customClasses.marginBO}`}>Marketing Email Notifications</h2>
                        <span className={classes.cardBody}>Email: <b>{email}</b></span>
                        <span>
                            <div className={classes.switchContainer}>
                                <p>Stay updated on exclusive offers and fresh gift and dessert concepts.</p>
                                {
                                    isUserSubscribedToMarketingEmails !== undefined ? (
                                        <div className={`${switchStyles.switchRoot} ${classes.switchInnerContainer}`}>
                                            {isUserSubscribedToMarketingEmails && (
                                                <span id="switchTextOn"
                                                    className={clsx(switchStyles.label, classes.switchOn)}
                                                >
                                                    ON
                                                </span>
                                            )}
                                            <FormControl variant="filled" fullWidth sx={{ m: 1 }}>
                                                <MuiSwitch
                                                    disableRipple
                                                    classes={{
                                                        root: classes.switchRoot,
                                                        switchBase: isUserSubscribedToMarketingEmails ? classes.switchBaseOn : classes.switchBaseOff,
                                                        thumb: classes.thumb,
                                                        track: !isUserSubscribedToMarketingEmails ? `${classes.switchTrack} ${classes.switchOffBg}` : classes.switchTrack,
                                                        checked: switchStyles.checked,
                                                    }}
                                                    checked={isUserSubscribedToMarketingEmails}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </FormControl>
                                            {!isUserSubscribedToMarketingEmails && (
                                                <span id="switchTextOff"
                                                    className={clsx(switchStyles.label, classes.switchOff)}
                                                    style={{ color: '#000000' }}
                                                >
                                                    OFF
                                                </span>
                                            )}
                                            {showSubscriptionStatus &&
                                                <p id="subscribedText" className={classes.subscribed}>
                                                    {getSubscriptionStatus()}
                                                </p>
                                            }
                                        </div>
                                    ) : <CircularProgress size={30} />
                                }
                            </div>
                            {
                                updateEmailSubscribeStatusMutation.isError && <p className={customClasses.error}>{UPDATE_FAIURE}</p>
                            }
                        </span>
                        <Divider />
                        <p id="legalCopy" className={customClasses.legalCopyFont}>By opting-out, you will no longer receive these communications. However, you will continue to receive email communications about the status of your order and reminders. You can update your email preferences every 30 minutes.</p>
                    </div>
                    {isShowingReminderPreferences &&
                        <div className="reminder-notification">
                            <h2 className={`${classes.sectionHeader} ${customClasses.marginBO}`}>Reminder Notification Preferences</h2>
                            <p>Reminder notifications for your contacts will be seamlessly delivered to your email address on file: <b>{email}</b></p>
                            <Divider />
                            <h3>Send me reminder notifications via text message.</h3>
                            <p>
                                <span>
                                    By toggling this option on, you consent to receive reminder notifications to the mobile number provided below.<br />
                                    <span className='links-container'>SMS messaging rates may apply. View <a className={customClasses.linkStyle} href={supportLinks.terms_of_use} rel="noreferrer" target="_blank">Terms of Use</a> and <a className={customClasses.linkStyle} href={supportLinks.privacy_notice} rel="noreferrer" target="_blank">Privacy Notice</a></span>
                                </span>
                                <div className='radio-btn'>
                                    {
                                        reminderNotification !== undefined ? (
                                            <div className={`${switchStyles.switchRoot} ${classes.switchInnerContainer}`}>
                                                {reminderNotification && (
                                                    <span id="switchTextOn"
                                                        className={clsx(switchStyles.label, classes.switchOn)}
                                                    >
                                                        ON
                                                    </span>
                                                )}
                                                <FormControl variant="filled" fullWidth sx={{ m: 1 }}>
                                                    <MuiSwitch
                                                        disableRipple
                                                        classes={{
                                                            root: classes.switchRoot,
                                                            switchBase: reminderNotification ? classes.switchBaseOn : classes.switchBaseOff,
                                                            thumb: classes.thumb,
                                                            track: !reminderNotification ? `${classes.switchTrack} ${classes.switchOffBg}` : classes.switchTrack,
                                                            checked: switchStyles.checked,
                                                        }}
                                                        checked={reminderNotification}
                                                        onChange={(e) => handleEnableReminderNotification(e)}
                                                    />
                                                </FormControl>
                                                {!reminderNotification && (
                                                    <span id="switchTextOff"
                                                        className={clsx(switchStyles.label, classes.switchOff)}
                                                        style={{ color: '#000000' }}
                                                    >
                                                        OFF
                                                    </span>
                                                )}
                                                {getPreferenceStatus()}
                                            </div>
                                        ) : <CircularProgress size={30} />
                                    }
                                </div>
                            </p>
                            {
                                fetchEmailSubscribeResponse.isLoading
                                    ? <GenericSkeleton height={50} />
                                    : (!isEditingPhoneNumber && phoneNumber)
                                        ? <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span className={classes.customerContactInfo}>Mobile Number: <b>{phoneNumber}</b></span>
                                            <Button
                                                size='small'
                                                variant='text'
                                                color='primary'
                                                className={classes.CTAButton}
                                                onClick={() => setIsEditingPhoneNumber(true)}
                                            >
                                                Edit
                                            </Button>
                                        </div> : <form
                                            onSubmit={methods.handleSubmit(onMobileNumberSave)}
                                            className={`field-container ${errors.phoneNumber ? 'error' : ''}`}
                                        >
                                            <TextFieldHelper
                                                methods={methods}
                                                required={false}
                                                variant="outlined"
                                                fieldName="phoneNumber"
                                                fieldLabel="Mobile Number"
                                                {...register('phoneNumber')}
                                                parentComponent="communicationCenter"
                                            />
                                            {apiErrorMessage && <span className={customClasses.apiError}>{apiErrorMessage}</span>}
                                            <Button
                                                type='submit'
                                                variant='contained'
                                                color='primary'
                                                fullWidth
                                                disabled={Object.keys(errors).length > 0}
                                            >
                                                SAVE
                                            </Button>
                                        </form>
                            }
                            <Divider className={isEditingPhoneNumber ? 'edit' : ''} />
                            <Link className={customClasses.linkStyle} to={`${getAppRoutePrefix()}/account/address-book`}>View or add upcoming reminders to your contacts</Link>
                            <p className="note">💡 To stop receiving reminders, delete any occasion reminders associated to an existing contact.</p>
                        </div>
                    }
                    {!isStandaloneAppChatLinkHidden &&
                        <div className={customClasses.footMargin}>
                            <h2 className={classes.sectionCustomizeCatalog}>Customize Your Catalog & Gift History</h2>
                            <p className={customClasses.mediumFont}>We're dedicated to eco-friendly practices, tailoring deliveries to your preferences. {operatingSystem === 'android' ? 'Chat with our call center' : <LinkOpenChat customClass={classes.chat}>Chat with our call center</LinkOpenChat>} for any additional communication preferences.</p>
                        </div>
                    }
                </div>
            </Grid >
        </RecipientBookContextProvider>
    )
};

export default CommunicationCenter;
